<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<!-- 			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.deviceNum" :placeholder="$tt('设备编号/IMEI/MAC')" >
					  <span slot="prepend">{{$tt('充电站')}}</span>
					</Input>
			</FormItem> -->
			<FormItem prop="trackName" :label="$tt('充电站:')" :label-width="100">
				<Select clearable filterable :placeholder="$tt('设备类型')" style="width: 200px;" v-model="formInline.deviceType">
					<!-- <Option value="0">{{$tt('深圳充电站')}}</Option>
					<Option value="1">{{$tt('罗湖充电站')}}</Option>
					<Option value="2">{{$tt('福田充电站')}}</Option> -->
				</Select>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')">{{$tt('查询')}}</Button>
			</FormItem>
		</Form>
		<Card style="margin-bottom: 20px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;background-color: white;">
			<Row>
				<Col span="5">
				<Tag color="success" type="dot">{{$tt('枪总数量')}}{{Summary.Total}}</Tag>
				</Col>
				<Col span="5">
				<Tag color="primary" type="dot">{{$tt('充电总数量')}}{{Summary.Charging}}</Tag>
				</Col>
				<Col span="4">
				<Tag color="warning" type="dot">{{$tt('待机总数量')}}{{Summary.Standby}}</Tag>
				</Col>
				<Col span="5">
				<Tag color="default" type="dot">{{$tt('离线数量')}}{{Summary.Offline}}</Tag>
				</Col>
				<Col span="5">
				<Tag color="error" type="dot">{{$tt('故障数量')}}{{Summary.Alarming}}</Tag>
				</Col>
			</Row>
		</Card>
		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight" ref="table" size="small">
		</Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getEqumentStatusUrl" @listData='getDeviceData'></MyPage>
	</div>
</template>

<script>
	import echarts1 from "../../../js/echarts_hot.js";
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import webapi from '../../../webapi.js';

	export default {
		data() {
			//自定义表单验证
			const latlng = (rule, value, callback) => {
				var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
				if (!latreg.test(value)) {
					callback(new Error("请填写正确经纬度格式"));
				} else {
					callback();
				}
			};
			return {
				getEqumentStatusUrl: webapi.base_api_url + '/Operations/GetEqumentStatus',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				//充电设备总计
				Summary: {
					Total: 0,
					Charging: 0,
					Standby: 0,
					Offline: 0,
					Alarming: 0,
				},
				//分页属性
				pageTotal: 10,
				pageSize: 10,
				opts: [10, 20, 30, 40],
				chectedPage: 1,
				BreadcrumbList: [this.$tt('场站监控'), '>>', this.$tt('设备状态')],
				formInline: {
					deviceNum: '',
					deviceStat: '',
					deviceType: ''
				},
				//table标题数据
				columns1: [{
						title: this.$tt('设备编号'),
						key: 'EquipmentNo',
					}, {
						title: this.$tt('设备名称'),
						key: 'EquipmentName',
					},
					{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo'
					},
					{
						title: this.$tt('枪名称'),
						key: 'ConnectorName'
					},
					{
						title: this.$tt('设备类型'),
						key: 'EquipmentType'
					},
					{
						title: this.$tt('枪类型'),
						key: 'ConnectorType'
					},
					{
						title: this.$tt('工作状态'),
						key: 'WorkStatus'
					},
					{
						title: this.$tt('告警码'),
						key: 'MaxAlarmCode'
					},
					{
						title: this.$tt('连接状态'),
						key: 'CarCoupleStatus'
					},
					{
						title: this.$tt('额定功率'),
						key: 'RatedPower'
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName'
					}, {
						title: this.$tt('操作'),
						key: 'action',
						width: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row.id)
										}
									}
								}, this.$tt('修改')),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("install", params.row.id)
										}
									}
								}, this.$tt('安装'))
							]);
						}
					}
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 300;
			window.addEventListener('resize', this.getTableHeight)
			_this.handleSubmit();
			//_this.GetUserStations();
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					deviceType: ''
				}
				return param
			},
		},
		methods: {
			handleSubmit: function() {
				const _this = this;
				let parms = {
					id: "params"
				}
				_this.$axios.post(webapi.base_api_url + "/Operations/GetEqumentStatus", parms, {
				}).then(res => {
					console.log("res")
					console.log(res.data)
					if (res.data.Code == 0) {
						_this.data1 = res.data.Data.Detail;
						_this.Summary = res.data.Data.Summary;
					}
				})
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.Detail
				_this.Summary = data.Data.Summary;
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 300;
			},
			GetUserStations: function() {
				const _this = this;
				let parms = {
					id: "params"
				}
				_this.$axios.post(webapi.base_api_url + "/Home/GetUserStations", parms, {
				}).then(res => {
					console.log("站点列表")
					console.log(res.data)
					if (res.data.Code == 0) {
						_this.data1 = res.data.Data.Detail;
						_this.Summary = res.data.Data.Summary;
					}
				})
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
